import { ApCheckbox } from '@alixpartners/ui-components';
import { ButtonMainLoader } from 'components/UIComponents/ButtonMainLoader';
import { useSettlementSingleContext } from '../../dataProvider/SettlementSingleContextProvider';
import './SettlementViewSavePanel.css';

export const SettlementViewSavePanel = () => {
  const {
    data,
    agreementDocument,
    loading,
    setFieldValue,
    clickButtonSave: buttonSaveClick,
  } = useSettlementSingleContext();

  return (
    <div className="settlememt-view-save-panel--container">
      <div className="settlememt-view-save-panel">
        {/* todo: uncomment comment field after backend is ready */}
        {/* <ApInput
          className="settlememt-view-save-panel__comment"
          //   disabled={!open}
          label="Add a comment about your updates for this settlement:"
          value={comment}
          onChange={onCommentChange}
        /> */}
        <div className="settlememt-view-save-panel__checkbox">
          {agreementDocument.documentReady && (
            <ApCheckbox
              id={'settlements-regenerate-agreement'} //
              label=""
              type="checkbox"
              checked={data?.regenerate}
              onChange={() => setFieldValue('regenerate')(!data?.regenerate)}
            >
              Regenerate Settlement Agreement
            </ApCheckbox>
          )}
        </div>
        <ButtonMainLoader
          loading={loading}
          onClick={buttonSaveClick}
          disabled={loading}
        >
          Save Changes
        </ButtonMainLoader>
      </div>
    </div>
  );
};
